import { useState } from 'react';
import { ApiError } from '@/services/api';
import { publicEventsApi } from '@/features/publicsite/events/api/publicEventsApi';
import {
  REGISTER_STATUS,
  registerFailureStatus,
} from '@/features/publicsite/events/registerStatus';
import type { RegisterStatus } from '@/features/publicsite/types/events/RegisterStatus';

/**
 * The "Înscrie-te la eveniment" button's request and the "Retrage înscrierea" one's, and where they
 * stand. `onChanged` lets the page re-read the visitor's own standing afterwards, so the button
 * shown next matches what the server now holds.
 */
export function useEventRegistration(onChanged: () => void) {
  const [registerStatus, setRegisterStatus] = useState<RegisterStatus>(REGISTER_STATUS.idle);

  const register = async (eventId: string) => {
    try {
      await publicEventsApi.register(eventId);
      setRegisterStatus(REGISTER_STATUS.done);
      onChanged();
    } catch (err) {
      // 401/403 both mean "not signed in far enough" — the page offers the way in rather than
      // reporting a failure the visitor cannot act on.
      const status = err instanceof ApiError ? err.problem.status : 0;
      setRegisterStatus(registerFailureStatus(status));
    }
  };

  const cancel = async (eventId: string) => {
    try {
      await publicEventsApi.cancelRegistration(eventId);
      setRegisterStatus(REGISTER_STATUS.cancelled);
      onChanged();
    } catch {
      setRegisterStatus(REGISTER_STATUS.failed);
    }
  };

  return { registerStatus, register, cancel };
}
